import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'CountryFormatter',
})
export class CountryFormatter implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'SE':
        return $localize`:@@countryFormatter.se:Sweden`;
      case 'DE':
        return $localize`:@@countryFormatter.de:Germany`;
      case 'AT':
        return $localize`:@@countryFormatter.at:Austria`;
      case 'NO':
        return $localize`:@@countryFormatter.no:Norway`;
      case 'FI':
        return $localize`:@@countryFormatter.fi:Finland`;
      default:
        break;
    }
  }
}
